import { createFileRoute } from '@tanstack/react-router';
import { buscaDaAuditoria } from '@/features/auditoria/busca';
import { Auditoria } from '@/features/auditoria/componentes/Auditoria';
import { rotaDaPlataforma } from '@/features/permissoes/guardas';

/** Eventos da plataforma, sem academia (spec 016; backend 011, CA-10). */
export const Route = createFileRoute('/_autenticado/plataforma/auditoria')({
  ...rotaDaPlataforma('Auditoria'),
  validateSearch: buscaDaAuditoria,
  component: Pagina,
});

function Pagina() {
  const valores = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Auditoria
      escopo="plataforma"
      semCabecalho
      busca={valores}
      aoMudarBusca={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
